import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./lib/auth";
import App from "./App";
import { ErroTela } from "./componentes/ErroTela";
import { instalarCapturaDeErros } from "./lib/erros";
import { registrarCacheDoApp } from "./lib/cacheApp";
import "./index.css";

instalarCapturaDeErros();
registrarCacheDoApp();

const cliente = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: true, staleTime: 5_000 } },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={cliente}>
      <BrowserRouter>
        <AuthProvider>
          <ErroTela>
            <App />
          </ErroTela>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
